import type { RelaunchDiffusionMutationResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { partenaires } from '~/msw/mocks/diffusion'

export function relaunchDiffusionHandler() {
  return http.post<
    { annonceId: string },
    never,
    RelaunchDiffusionMutationResponse
  >('http://localhost:3000/api/v1/diffusions/:annonceId/relancer', () => {
    // Relance globale : un résultat par produit de diffusion.
    return HttpResponse.json(
      partenaires.map(p => ({
        produit: p.label,
        success: true,
        message: 'Annonce relancée avec succès',
      })),
    )
  })
}

// Variante « scenario » de l'endpoint : la relance globale échoue (HTTP 500).
// Branchée via ?scenario=relaunchError et composée dans ~/msw/scenarios.ts pour
// tester le toast d'erreur « La publication a échoué » (cf. useDiffusion).
export function relaunchDiffusionErrorHandler() {
  return http.post(
    'http://localhost:3000/api/v1/diffusions/:annonceId/relancer',
    () => HttpResponse.json({ message: 'Échec de la relance' }, { status: 500 }),
  )
}
